/**
* @file AdminTrainingCreateEditForm.js
 
* @author - (Meera,Keerthana,Bhavithra)
* @sprint - B2W-Sprint-6
* @description -
* This component is a modal form used to create or update  Training.
* 
*/
import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, DatePicker, TimePicker, Button, message,Spin } from "antd";
import moment from 'moment';
import dayjs from "dayjs";
import { DATE_FORMAT,TIME_FORMAT } from "../../constants";
import { MdOutlineEditRoad } from "react-icons/md";
import training from "../../pages/Admin/TrainingLabels.json"

const { RangePicker: DateRangePicker } = DatePicker;
const { RangePicker: TimeRangePicker } = TimePicker;
const AdminTrainingCreateEditForm = ({ visible, setVisible, onCreate, selectedRecord,onEdit }) => {
  const [form] = Form.useForm();
  const [isUpdated, setIsUpdated] = useState(false);
  const [loading, setLoading] = useState(false);  // State to track loading

  /**
  * Handles form submission.
  * Validates and collects form values, formats the data, and triggers the appropriate callback.
  */

  
useEffect(() => {
      if (selectedRecord) {
        form.setFieldsValue({
          trainingName: selectedRecord.trainingName,
          description: selectedRecord.description,
          trainingDate: [moment(selectedRecord.trainingStartDate, DATE_FORMAT), moment(selectedRecord.trainingEndDate, DATE_FORMAT)],
          trainingTime: [moment(selectedRecord.startTime, TIME_FORMAT), moment(selectedRecord.endTime, TIME_FORMAT)],
          emailId: selectedRecord.emailId,
          prerequisites: selectedRecord.prerequisites,
          trainingMode: selectedRecord.trainingMode,
          certificate: selectedRecord.certificate,
          trainingType: selectedRecord.trainingType,
          trainingLink: selectedRecord.trainingLink,
        });
      }
    }, [selectedRecord, form]);

  const handleCreate = () => {
    setLoading(true);  // Start loading when submitting
    
      console.log('Loading state after setting to true:', loading); // This should print `true`
  
    
    form
      .validateFields()
      .then((values) => {
        // Format date range
        const [startDate, endDate] = values.trainingDate || [];
        const [startTime, endTime] = values.trainingTime || [];

        const formattedData = {
          ...values,
          trainingName: values.trainingName?.trim(),
          description: values.description?.trim(),
          prerequisites: values['prerequisites']?.trim(),
          trainingDate: {
            start: startDate ? dayjs(startDate).format(DATE_FORMAT) : null,
            end: endDate ? dayjs(endDate).format(DATE_FORMAT) : null,
          },
          trainingTime: {
            start: startTime ? dayjs(startTime).format(TIME_FORMAT) : null,
            end: endTime ? dayjs(endTime).format(TIME_FORMAT) : null,
          },
        };
        
        onCreate(formattedData);

        message.success("Training details submitted!");
        form.resetFields();
        setVisible(false);
        setLoading(false);  // Stop loading after submission
      })
      .catch((info) => {
        console.error("Validation Failed:", info);
        message.error("Please fix the form errors before submitting.");
        setLoading(false);  // Stop loading if validation fails
      });
  };


  

  const handleEdit = () => {
    setLoading(true);  // Start loading when submitting
      form
        .validateFields()
        .then((values) => {
          // Format date range
          const [startDate, endDate] = values.trainingDate || [];
          const [startTime, endTime] = values.trainingTime || [];
    
          const formattedData = {
            ...selectedRecord,
            ...values,
            trainingName: values.trainingName?.trim(),
            description: values.description?.trim(),
            prerequisites: values.prerequisites?.trim(),
            trainingDate: {
              start: startDate ? dayjs(startDate).format(DATE_FORMAT) : null,
              end: endDate ? dayjs(endDate).format(DATE_FORMAT) : null,
            },
            trainingTime: {
              start: startTime ? dayjs(startTime).format(TIME_FORMAT) : null,
              end: endTime ? dayjs(endTime).format(TIME_FORMAT) : null,
            },
          };
    
          onEdit(formattedData);
    
          message.success("Training details updated!");
          form.resetFields();
          setVisible(false);
    setLoading(false);  // Stop loading after submission
        })
        .catch((info) => {
          console.error("Validation Failed:", info);
          message.error("Please fix the form errors before submitting.");
    setLoading(false);  // Stop loading if validation fails
        });
    };
    


  
const handleOk = () => {
      if (selectedRecord) {
        handleEdit();
      } else {
        handleCreate();
      }
    };
  
  


  /**
 * Handles modal close action.
 * Resets form if no record is selected and closes the modal.
 */
  const handleCancel = () => {
    if (!selectedRecord) {
      form.resetFields(); // Clear all form fields
    }
    form.resetFields();
    setVisible(false); // Close modal
  };

  /**
   * Handles form field changes.
   * Enables the update button when a field is modified.
   */
  const handleValuesChange = () => {
    // Check if any field value is changed, if so, enable the Update button
    setIsUpdated(true);
  };
  // Set modal height to be less than the window height
  const modalHeight = window.innerHeight * 0.8; // 80% of the window height

  const disabledDate = (current) => {
    return current && current < moment().startOf('day');
  };

  return (
    <Modal
      open={visible}

      title={

        <div className=" pt-2 pb-2 px-4 pl-0 rounded-lg sticky top-0 bg-white z-10">
          {/* <span className="inline-block text-primary p-2 pl-0 text-xl"> */}
           <span className="inline-block p-2 pl-0 text-xl" style={{ color: 'rgb(44, 87, 120)' }}> 
            {selectedRecord ? training.editTraining : training.addTraining}
          </span>
        </div>
      }


      okText={selectedRecord ? training.updateButton : training.submitButton}
      onCancel={handleCancel}  // Use handleCancel to reset fields and close modal

      onOk={handleOk}  // Submit form on OK
   
      okButtonProps={{
        className: "text-white border p-4 bg-[var(--color-primary)]",
        style: !isUpdated ? {
                  color: 'white', 
                  cursor: 'not-allowed', // Change the cursor to indicate the button is disabled
                  opacity: 0.6 // Optional: Make the button appear slightly faded
                } : {},
        disabled: !isUpdated, // Disable the button if nothing has been updated
      }}
      cancelButtonProps={{
        className: "text-white border p-4 bg-[var(--color-primary)]"

      }}
      style={{
        maxHeight: `${modalHeight}px`,
        overflowY: 'hidden', // Prevents the modal itself from scrolling
      }}
      maskClosable={false} // Prevents closing on outside click
    >
       <Spin spinning={loading} tip="Processing..." size="large">
      <div className="modal-content-wrapper" style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
        <Form form={form} layout="vertical" onValuesChange={handleValuesChange}   >

         
           {/* Training Name Field */}
          <Form.Item
            name="trainingName"  // Corrected the typo here
            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{training.trainingName}</span>}
            rules={[
              {
                required: true,
                message: training.trainingName_Mandatory_Validation // Added a custom message for the required field
              }

            ]}
          >
            <Input
              className="w-full " placeholder={training.trainingName_Placeholder}
            />
          </Form.Item>


          {/* Comments Field */}
          <Form.Item
            name="description"
            // label={<span className="text-[rgb(44, 87, 120)] font-bold">Comment</span>}
            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{training.description}</span>}
            rules={[{ required: true,
               message: training.description_Mandatory_Validations },
            { max: 500, 
              // message: "Description cannot exceed 500 characters!" 
              message:training.description_Validation
            }
            ]}
          >
            <Input.TextArea className="w-full " placeholder={training.description_Placeholder}/>
          </Form.Item>


          {/* RangePicker Field */}
          <Form.Item
            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{training.trainingDate}</span>}
            name="trainingDate"
            rules={[{ required: true, message: training.trainingDate_Mandatory_Validation }]}
          >
            <DateRangePicker
              className="w-full"
              format="DD-MM-YYYY"
              disabledDate={disabledDate}
            // This disables manual editing
            />
          </Form.Item>

          <Form.Item
            name="trainingTime"
            label={
              <span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>
                {training.trainingTime}
              </span>
            }
            rules={[
              {
                required: true,
                message: training.trainingTime_Mandatory_Validation,
              },
            ]}
          >
            <TimeRangePicker  className="w-full" format="HH:mm" />
          </Form.Item>

          <Form.Item
            name="emailId"
            label={
              <span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>
                {training.trainingPOC}
              </span>
            }
            rules={[
              {
                required: true,
                message: training.trainingPOC_Mandatory_Validation,
              },
              {
                validator: (_, value) =>
                  !value || /^[^\s@]+@ust\.com$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error('Email must be in the format name@ust.com.')),
              },
            ]}
          >
            <Input placeholder={training.trainingPOC_Placeholder} />
          </Form.Item>





          {/* Comments Field */}
          <Form.Item
            name="prerequisites"

            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{training.prerequisites}</span>}
            rules={[{ required: true, message: training.prerequisites_Mandatory_Validation },
            { max: 500, message: training.prerequisites_Validation }
            ]}
          >
            <Input.TextArea className="w-full " placeholder={training.prerequisites_Placeholder}/>
          </Form.Item>





          <Form.Item
            name="trainingMode"
            label={
              <span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>
                {training.trainingMode}
              </span>
            }
            rules={[
              {
                required: true,
                message: training.trainingMode_Mandatory_Validation,
              },
            ]}
          >
            <Select placeholder={training.trainingMode_Placeholder}>
              <Select.Option value="virtual">Virtual</Select.Option>
              <Select.Option value="office">Office</Select.Option>
            </Select>
          </Form.Item>



          <Form.Item
            name="certificate"
            label={
              <span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>
                {training.certificate}
              </span>
            }
          >
            <Select placeholder={training.certificate_Placeholder}>
              <Select.Option value="yes">Yes</Select.Option>
              <Select.Option value="no">No</Select.Option>
            </Select>
          </Form.Item>


          <Form.Item
            name="trainingType"
            label={
              <span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>
                {training.trainingType}
              </span>
            }
          >
            <Select placeholder="Select Trainimg Type">
              <Select.Option value="internal">Internal</Select.Option>
              <Select.Option value="external">External</Select.Option>
            </Select>
          </Form.Item>


          <Form.Item
            name="trainingLink"  // This will be used to access the link value in the form
            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{training.trainingLink}</span>}
          // rules={[{ required: true, message: "Please provide a valid link!" }]} // You can add more validations here if needed
          >
            <Input placeholder="Enter the training link (e.g., https://example.com)" />
          </Form.Item>
        </Form>
      </div>
      </Spin>
    </Modal>
  );
};

export default AdminTrainingCreateEditForm;